import Flatpickr from 'react-flatpickr';
import styled from 'styled-components';

export const AdminDatePickerStyled = styled(Flatpickr)`
  width: 250px;
  border: none;
  border-radius: 200px;
  font-size: ${({ theme }) => theme.input.fontSize};
  line-height: 18px;
  padding: 12.5px 24px 12.5px 16px;
  -moz-appearance: none;
  -webkit-appearance: none;
  appearance: none;

  background-repeat: no-repeat;
  background-position: right 1rem center;
  background-size: 1em;
  cursor: pointer;

  :focus {
    outline: none !important;
  }
`;

export const FlatpickrStyled = styled.div<{ $noCalendar?: boolean }>`
  .flatpickr-calendar.rangeMode.animate.inline {
    margin: 0 !important;
  }

  .flatpickr-day.inRange {
    background: #f7f7f7;
    border-color: #f7f7f7;
    border-radius: 50%;
    box-shadow: none;
  }

  .flatpickr-day.selected,
  .flatpickr-day.startRange,
  .flatpickr-day.endRange,
  .flatpickr-day.selected.inRange,
  .flatpickr-day.startRange.inRange,
  .flatpickr-day.endRange.inRange,
  .flatpickr-day.selected:focus,
  .flatpickr-day.startRange:focus,
  .flatpickr-day.endRange:focus,
  .flatpickr-day.selected:hover,
  .flatpickr-day.startRange:hover,
  .flatpickr-day.endRange:hover,
  .flatpickr-day.selected.prevMonthDay,
  .flatpickr-day.startRange.prevMonthDay,
  .flatpickr-day.endRange.prevMonthDay,
  .flatpickr-day.selected.nextMonthDay,
  .flatpickr-day.startRange.nextMonthDay,
  .flatpickr-day.endRange.nextMonthDay {
    background: ${({ theme }) => theme.primary};
    border-color: ${({ theme }) => theme.primary};
    color: #fff;
    border-radius: 50%;
    box-shadow: none !important;
  }

  .flatpickr-day.selected.endRange,
  .flatpickr-day.startRange.endRange,
  .flatpickr-day.endRange.endRange,
  .flatpickr-day.selected.startRange,
  .flatpickr-day.startRange.startRange {
    border-radius: 50%;
  }

  .flatpickr-day.today {
    border-color: ${({ theme }) => theme.primary};
  }

  .flatpickr-calendar {
    border: none;
    border: none;
    box-shadow: none;
    background: none;
    ${({ $noCalendar }) =>
      $noCalendar &&
      `
        width: 200px !important;
      `}
  }

  .flatpickr-weekday {
    font-weight: normal !important;
  }

  .flatpickr-weekdays {
    height: 50px;
  }

  .flatpickr-input {
    display: none;
    pointer-events: none;
  }

  .flatpickr-current-month .flatpickr-monthDropdown-months {
    -moz-appearance: none !important; /* Firefox */
    -webkit-appearance: none !important; /* Safari and Chrome */
    appearance: none !important;
  }

  .flatpickr-current-month .flatpickr-monthDropdown-months:hover {
    background: none;
    color: ${({ theme }) => theme.primary};
  }

  .flatpickr-time .numInputWrapper {
    width: 40% !important;
  }

  .flatpickr-time .flatpickr-time-separator {
    width: 7% !important;
  }

  .flatpickr-time {
    font-size: 18px;
    input {
      ::selection {
        background: ${({ theme }) => theme.gray} !important;
      }
      font-size: 18px;
      &:focus {
        background: none !important;
        -webkit-tap-highlight-color: transparent !important;
        outline: none !important;
      }
    }
    input.flatpickr-hour {
      font-weight: 400;
    }
  }

  .flatpickr-time input:hover,
  .flatpickr-time .flatpickr-am-pm:hover,
  .flatpickr-time input:focus,
  .flatpickr-time .flatpickr-am-pm:focus {
    background: none !important;
    -webkit-tap-highlight-color: transparent !important;
    outline: none !important;
  }

  .numInputWrapper:hover {
    background: none;
    .arrowUp,
    .arrowDown {
      border: none !important;
    }
  }

  .numInputWrapper span {
    background: none;
  }

  .numInputWrapper span:hover {
    background: none;
  }

  .numInputWrapper span:hover :after {
    border-top-color: red;
  }

  .flatpickr-monthSelect-month:hover {
    border-radius: 100px;
  }

  .flatpickr-monthSelect-month.today {
    border-color: ${({ theme }) => theme.primary};
    border-radius: 100px;
  }

  .flatpickr-monthSelect-month.today:hover {
    background: #e6e6e6;
    color: #393939;
  }

  .flatpickr-monthSelect-month.selected {
    background: ${({ theme }) => theme.primary};
    border-color: ${({ theme }) => theme.primary};
    color: #fff;
    box-shadow: none !important;
    border-radius: 100px;
  }

  .flatpickr-monthSelect-month {
  }

  .flatpickr-monthSelect-month.endRange {
    border-radius: 0 50px 50px 0;
    background: ${({ theme }) => theme.primary};
    border-color: ${({ theme }) => theme.primary};
  }

  .flatpickr-monthSelect-month.startRange {
    border-radius: 50px 0 0 50px;
    background: ${({ theme }) => theme.primary};
    border-color: ${({ theme }) => theme.primary};
  }

  .flatpickr-monthSelect-month.inRange {
    /* background: #f7f7f7;
    border-color: #f7f7f7; */
    border-radius: 0;
  }

  .flatpickr-time {
    border: none !important;
  }

  .flatpickr-time input:focus,
  .flatpickr-time input:hover {
    background: none;
  }

  .flatpickr-calendar .flatpickr-prev-month,
  .flatpickr-calendar .flatpickr-next-month {
    display: block !important; /* Always show */
    visibility: visible !important;
    pointer-events: auto !important; /* Keep clickable */
    opacity: 1; /* Optional: make it look disabled */
  }

  .flatpickr-calendar .flatpickr-prev-month.flatpickr-disabled,
  .flatpickr-calendar .flatpickr-next-month.flatpickr-disabled {
    opacity: 0.3;
    pointer-events: none; /* prevent clicking outside allowed range */
    cursor: not-allowed;
  }
`;
